import { render } from "./BestFlats.vue?vue&type=template&id=61d47d92&scoped=true"
import script from "./BestFlats.vue?vue&type=script&lang=js"
export * from "./BestFlats.vue?vue&type=script&lang=js"

import "./BestFlats.vue?vue&type=style&index=0&id=61d47d92&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d47d92"]])

export default __exports__